import { ROUTE } from '@lib/core/const';
import { Uuid } from '@lib/core/type';

export class Device {
  constructor(
    public readonly id: Uuid,
    public readonly vendor: string,
    public readonly model: string,
    public readonly alias: string | null,
    public readonly imei: string | null,
    public readonly serialNumber: string | null
  ) {}

  public get link(): string[] {
    return [ROUTE.BASE, ROUTE.DEVICE.BASE, this.id];
  }

  public getDisplayName(): string {
    return `${this.vendor} ${this.model}`;
  }
}
